export enum FlowActionType {
	WorkChange,
	ResumeFail,
	ResumeOn,
	ResumeOff,
}

